import isArray from "./util/is-array"

export default class Entities
{
    constructor()
    {
        this.entities = [];

        this.synched = [];
        this.synchedDirty = false;
    }

    get(index)
    {
        return this.entities[index];
    }

    count()
    {
        return this.entities.length;
    }

    add(entity)
    {
        if (isArray(entity))
        {
            this.entities = this.entities.concat(entity);
        }
        else
        {
            this.entities.push(entity);
        }

        this.synchedDirty = true;
    }

    sync()
    {
        if (this.synchedDirty)
        {
            this.synched = this.entities.filter(e => !!e.sync);
            this.synchedDirty = false;
        }

        let synched = this.synched;

        const len = synched.length;
        for (let i = 0; i < len; i++)
        {
            synched[i].sync();
        }
    }

}



// WEBPACK FOOTER //
// ./src/entities.js